import { useCallback } from 'react';
import { gameProviderTypes } from '@configs/layout';
import { RootState } from '@reducers/index';
import { useSelector } from 'react-redux';
import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';

interface IProp {
  closeHandler: () => void;
  selectAppTextHandler: (appTitle: string) => void;
}

const MyAppList = ({ closeHandler, selectAppTextHandler }: IProp) => {
  const { allMyAppListInfo } = useSelector(({ serviceManager }: RootState) => serviceManager);
  console.log('allMyAppListInfo: ', allMyAppListInfo);

  const onClickHandler = useCallback(
    (appObj: IResponseRegisteredAppInfo) => {
      selectAppTextHandler(appObj?.title);
      closeHandler();
    },
    [closeHandler, selectAppTextHandler]
  );

  return (
    <>
      <ul className="search-list active">
        <li>
          <span>
            <b>My App</b>
          </span>
        </li>
        {/* {!!myAppInfoList && myAppInfoList.length > 0 && (
          <>
            {myAppInfoList.map((item, index) => (
              <li key={index} onClick={() => onClickHandler(item)} onMouseDown={() => onClickHandler(item)}>
                <button style={{ width: 'inherit', height: 'inherit' }} type="button">
                  {item.provider_type === gameProviderTypes.GooglePlayStore ? (
                    <p className="btn-ico-single android"></p>
                  ) : (
                    <p className="btn-ico-single app"></p>
                  )}
                  <img style={{ width: 'inherit', height: 'inherit' }} src={item.icon} />
                  <span>{item.title}</span>
                </button>
              </li>
            ))}
          </>
        )} */}
        {!!allMyAppListInfo && allMyAppListInfo.length > 0 && (
          <>
            {allMyAppListInfo.map((item, index) => (
              <li
                key={index}
                onClick={() => onClickHandler(item.myAppInfo)}
                onMouseDown={() => onClickHandler(item.myAppInfo)}
              >
                <button style={{ width: 'inherit', height: 'inherit' }} type="button">
                  {item.myAppInfo.provider_type === gameProviderTypes.GooglePlayStore ? (
                    <p className="btn-ico-single android"></p>
                  ) : (
                    <p className="btn-ico-single app"></p>
                  )}
                  <img style={{ width: 'inherit', height: 'inherit' }} src={item.myAppInfo.icon} />
                  <span>{item.myAppInfo.title}</span>
                </button>
              </li>
            ))}
          </>
        )}
      </ul>
    </>
  );
};

export default MyAppList;
